export const createDeleteFileUIKey = id => `DELETE_FILE_${id}`;
